module.exports = __webpack_public_path__ + "static/media/arrow_up.82a1840c.svg";